<template>
  <li v-if="showLink">
    <CustomLink
      :url="url"
      :type="LINK_TYPE.NoStyle"
      :gtm-id="link.gtmId"
    >
      <div
        class="flex items-center gap-2"
      >
        <span class="text-sm">
          {{ name }}
        </span>
        <InfoTag
          v-if="link.tag"
          :text="$t(link.tag)"
        />
      </div>
    </CustomLink>
  </li>
</template>

<script lang="ts">

import type { FooterLink } from '~~/types/cms/Footer/FooterLink/FooterLink';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

import { instanceOfFooterLink } from '~~/types/cms/Footer/FooterLink/instanceOfFooterLink';

export default defineComponent({
  name: 'FooterLinkItem',

  props: {
    link: {
      type: Object as PropType<FooterLink>,
      default: (): FooterLink => ({}),
      validator: (link: FooterLink) => {

        return !!instanceOfFooterLink(link);

      },
    },
  },
  setup(props) {

    const i18n = useI18n();
    const { getUrlByRouteKey } = useRouteExtended();
    const url = computed(() => {

      if (props.link.routeKey) {

        return getUrlByRouteKey(props.link.routeKey);

      }

      if (props.link.url) {

        return props.link.url;

      }

      return '';

    });
    const name = computed(() => props.link.translationKey ? i18n.t(props.link.translationKey) : props.link.name);
    const showLink = computed(() => !!(url.value && name.value));

    return {
      LINK_TYPE,
      url,
      name,
      showLink,
    };

  },
});

</script>
